import request from "@/utils/request";
// import {getcpyNo} from '@/utils/auth';
// 资格表查询
export function standardQueryApi(data) {
    return request({
        url: "/api/gfriend/gfstandard/query",
        method: "GET",
        params: data
    })
}
// 资格表条件查询
export function standardSearchApi(data) {
    return request({
        url: "/api/gfriend/gfstandard/query",
        method: "POST",
        params: data
    })
}
// 资格表--删除
export function standardDeleteApi(data) {
    return request({
        url: "/api/gfriend/gfstandard/delete",
        method: "post",
        params: data
    })
}
// 资格表--创建
export function standardInsertApi(data) {
    return request({
        url: "/api/gfriend/gfstandard/insert",
        method: "post",
        params: data
    })
}
// 资格表--修改
export function standardUpdate(data) {
    return request({
        url: "/api/gfriend/gfstandard/update",
        method: "post",
        params: data
    })
}
//--------------------------------
// 资格表申请---查詢
export function friendQuery(data) {
    return request({
        url: "/api/gfriend/gfrequest/query",
        method: "get",
        params: data
    })
}
// 资格表申请--新增
export function friendInsert(data) {
    return request({
        url: "/api/gfriend/gfrequest/insert",
        method: "post",
        params: data
    })
}
// 资格表申请--修改
export function friendUpdate(data) {
    return request({
        url: "/api/gfriend/gfrequest/update",
        method: "post",
        params: data
    })
}
// 资格表申请--刪除
export function friendDelete(data) {
    return request({
        url: "/api/gfriend/gfrequest/delete",
        method: "post",
        params: data
    })
}
//-------------
// GFriends管理查询
// export const tubeQueryApi=(params)=>request.post("/api/gfriend/gfriends/query",params);
export function tubeQueryApi(data) {
    return request({
        url: "/api/gfriend/gfriends/query",
        method: "GET",
        params: data
    })
}
//重新绑定会员
export function bindApi(data) {
    return request({
        url: "/api/gfriend/gfriends/bind",
        method: "POST",
        params: data
    })
}
// 删除
export function deleteApi(data) {
    return request({
        url: "/api/gfriend/gfriends/delete",
        method: "POST",
        params: data
    })
}
// 编辑
export function editApi(data) {
    return request({
        url: "/api/gfriend/gfriends/edit",
        method: "POST",
        params: data
    })
}
// 冻结
export function freezeApi(data) {
    return request({
        url: "/api/gfriend/gfriends/freeze",
        method: "POST",
        params: data
    })
}
// 解冻
export function unfreezeApi(data) {
    return request({
        url: "/api/gfriend/gfriends/unfreeze",
        method: "POST",
        params: data
    })
}
//------小程序资讯页---------
// 分页
export function lectInfoPageApi(data) {
    return request({
        url: "/api/gfriend/gfapplect/info/page",
        method: "GET",
        params: data
    })
}
// 查询
export function searchApi(data) {
    return request({
        url: "/api/gfriend/gfapplect/info/selectById",
        method: "GET",
        params: data
    })
}


// 获取GF信息
export function getGFInfo(data) {
    return request({
        url: "/api/gfriend/gfriends/selectById",
        method: "POST",
        params: data
    })
}


// 获取积分信息
export function getPointInfo(data) {
    return request({
        url: "/api/gfriend/gfriends/getPointInfo",
        method: "POST",
        params: data
    })
}

// 获取积分列表
export function getPointTable(data) {
    return request({
        url: "/api/gfriend/gftpointslog/page",
        method: "POST",
        params: data
    })
}


// 获取推荐会员清单
export function getReferCustPage(data) {
    return request({
        url: "/api/gfriend/gfriends/referCustPage",
        method: "POST",
        params: data
    })
}

// 获取陪同客户销售单列表
export function getcustSalePage(data) {
    return request({
        url: "/api/gfriend/gfriends/custSalePage",
        method: "POST",
        params: data
    })
}


// 获取gf分享模板列表
export function getGFShareList(data) {
    return request({
        url: "/api/gfriend/gfshare/page",
        method: "POST",
        params: data
    })
}


//gf分享模板添加
export function addShare(data) {
    return request({
        url: "/api/gfriend/gfshare/insert",
        method: "POST",
        params: data
    })
}



//gf分享模板修改
export function updateShare(data) {
    return request({
        url: "/api/gfriend/gfshare/update",
        method: "POST",
        params: data
    })
}



//gf分享模板修改
export function deleteShare(data) {
    return request({
        url: "/api/gfriend/gfshare/delete",
        method: "POST",
        params: data
    })
}


//获取gf可分享产品列表
export function getShareableList(data) {
    return request({
        url: "/api/gfriend/share/product/page",
        method: "POST",
        params: data
    })
}


//获取产品分类
export function getProductType(data) {
    return request({
        url: "/api/gfriend/share/product/list",
        method: "POST",
        params: data
    })
}


//删除可分享产品
export function deleteSharePrdouct(data) {
    return request({
        url: "/api/gfriend/share/product/delete",
        method: "POST",
        params: data
    })
}



//修改可分享产品
export function upDateSharePrdouct(data) {
    return request({
        url: "/api/gfriend/share/product/update",
        method: "POST",
        params: data
    })
}


//创建可分享产品
export function insertSharePrdouct(data) {
    return request({
        url: "/api/gfriend/share/product/insert",
        method: "POST",
        params: data
    })
}




//删除小程序资讯
export function deleteRealTimeInfo(data) {
    return request({
        url: "/api/gfriend/gfapplect/info/delete",
        method: "POST",
        params: data
    })
}


//创建小程序资讯
export function addRealTimeInfo(data) {
    return request({
        url: "/api/gfriend/gfapplect/info/insert",
        method: "POST",
        params: data
    })
}


//修改小程序资讯
export function updateRealTimeInfo(data) {
    return request({
        url: "/api/gfriend/gfapplect/info/update",
        method: "POST",
        params: data
    })
}



//可分享产品选择商品列表获取
export function selectProduct(data) {
    return request({
        url: "/api/product/baseSelectProduct",
        method: "POST",
        params: data
    })
}



//可分享产品选择商品列表获取
export function applyExamine(data) {
    return request({
        url: "/api/gfriend/gfrequest/verify",
        method: "POST",
        params: data
    })
}


//可分享产品选择商品编码获取
export function getProductCode(data) {
    return request({
        url: "/api/gfriend/share/product/getCode",
        method: "POST",
        params: data
    })
}

// GF导出
export function GfriendsexportApi(data) {
    return request({
        url:"/api/gfriend/gfriends/export",
        method: "GET",
        params: data
    })
} 






